export default __webpack_public_path__ + "./dist/images/d0459f25df0fbb1f89a13e0408122073-errorhedgehog.png";